// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let AuthSession = require("../../../utils/AuthSession.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ReadMoreButton = require("../../../components/buttons/ReadMoreButton.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let NotificationsUtils = require("../../../v5/common/notifications/NotificationsUtils.bs.js");
let FragmentErrorBoundary = require("../../../v5/common/ErrorHandling/FragmentErrorBoundary.bs.js");
let NotificationWidgetItem = require("./NotificationWidgetItem.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let NotificationWidgetRelay_query_graphql = require("../../../__generated__/NotificationWidgetRelay_query_graphql.bs.js");
let NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql = require("../../../__generated__/NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.bs.js");

let convertFragment = NotificationWidgetRelay_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, NotificationWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(NotificationWidgetRelay_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, NotificationWidgetRelay_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(NotificationWidgetRelay_query_graphql.node, convertFragment, fRef);
}

let QueryFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Internal.convertVariables;

let convertResponse = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use$1 = RescriptRelay_Mutation.useMutation(convertVariables, NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.node, convertResponse, convertWrapRawResponse);

let MarkNotificationReadByCurrentUserMutation_notificationStatus_decode = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Utils.notificationStatus_decode;

let MarkNotificationReadByCurrentUserMutation_notificationStatus_fromString = NotificationWidgetRelay_MarkNotificationReadByCurrentUserMutation_graphql.Utils.notificationStatus_fromString;

let MarkNotificationReadByCurrentUserMutation = {
  notificationStatus_decode: MarkNotificationReadByCurrentUserMutation_notificationStatus_decode,
  notificationStatus_fromString: MarkNotificationReadByCurrentUserMutation_notificationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function NotificationWidgetRelay$WithoutErrorBoundary(props) {
  let query = RescriptRelay_Fragment.useFragment(NotificationWidgetRelay_query_graphql.node, convertFragment, props.query);
  let isImpersonated = AuthSession.useIsImpersonated();
  let match = use$1();
  let markNotificationAsread = match[0];
  let markAsRead = id => {
    if (isImpersonated) {
      return;
    } else {
      markNotificationAsread({
        input: {
          id: id
        }
      }, undefined, undefined, undefined, undefined, undefined, undefined);
      return;
    }
  };
  let notifications = Stdlib_Array.filterMap(Stdlib_Option.getOr(Stdlib_Option.flatMap(query.notificationsForCurrentUserV5, v => v.edges), []), v => {
    if (v !== undefined) {
      return v.node;
    }
  });
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
    children: [
      JsxRuntime.jsx("div", {
        children: NotificationsUtils.NotificationGrouper.groupNotifications(notifications, v => Scalars.DateTime.toUTC(v.createdAt)).map(x => {
          let groupTime = NotificationsUtils.NotificationGrouper.toString(x[0]);
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("h3", {
                children: groupTime,
                className: "text-2xl font-medium text-gray-800"
              }),
              JsxRuntime.jsx("div", {
                children: x[1].map(v => JsxRuntime.jsx(FragmentErrorBoundary.make, {
                  fragmentDisplayName: "notification widget item",
                  children: JsxRuntime.jsx(NotificationWidgetItem.make, {
                    notification: v.fragmentRefs,
                    markAsRead: markAsRead
                  })
                }, v.nodeId)),
                className: "mt-4"
              })
            ]
          }, groupTime);
        }),
        className: "mb-8 flex flex-col space-y-12"
      }),
      props.showMore && notifications.length !== 0 ? JsxRuntime.jsx(ReadMoreButton.make, {
          href: "/notifications",
          children: "View All"
        }) : null
    ]
  });
}

let WithoutErrorBoundary = {
  make: NotificationWidgetRelay$WithoutErrorBoundary
};

function NotificationWidgetRelay(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "notifications",
    children: JsxRuntime.jsx(NotificationWidgetRelay$WithoutErrorBoundary, {
      query: props.query,
      showMore: props.showMore
    })
  });
}

let NotificationGrouper;

let make = NotificationWidgetRelay;

exports.NotificationGrouper = NotificationGrouper;
exports.QueryFragment = QueryFragment;
exports.MarkNotificationReadByCurrentUserMutation = MarkNotificationReadByCurrentUserMutation;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* commitMutation Not a pure module */
